/* eslint-disable */
import { useContext } from "react";

import { PolicyInstallment } from "../../models/policyInstallment";
import { useGetPolicyInstallmentsQuery } from "../../store/policiesSlice";
import { InstallmentCard } from "../../components/policy/InstallmentCard";
import { LocalizationContext } from "../../App";
import { ReceiptOutline } from "../../common/icons";

export const PolicyInstallmentList = () => {
  const l10n = useContext(LocalizationContext);
  const { data: installments, isLoading } = useGetPolicyInstallmentsQuery();

  if (isLoading)
    return (
      <div className="loading-screen flex flex-col justify-center items-center">
        <div className="text-body text-xl">{l10n.common.loading}</div>
      </div>
    );

  const installmentsToShow =
    installments?.filter((i) => !!i.erpReference && i.erpReference !== "") ?? [];

  return (
    <>
      <h2>{l10n.title.invoices}</h2>

      {installmentsToShow?.length ? (
        installmentsToShow.map((installment: PolicyInstallment, index: number) => (
          <InstallmentCard key={index} installment={installment} />
        ))
      ) : (
        <div className="no-data-screen flex flex-col justify-center items-center text-center text-body px-4">
          <ReceiptOutline className="w-32 h-32 stroke-no-data stroke-1" />
          <div className="mt-4 text-body">{l10n.policy.noInstallments}</div>
        </div>
      )}
    </>
  );
};
